// test1478
(1478 && 0);
